export const GALLERY_CANNOT_PURCHASE_ERROR_TYPE = 'GALLERY_CANNOT_PURCHASE';
